import NoPlanPage from '@/ui/pages/subscription/NoPlanPage.vue';
import SubscriptionEndedPage from '@/ui/pages/subscription/SubscriptionEndedPage.vue';
import { guardAuthenticatedRoutes } from '@/ui/routes/guards';
import { NamedRouteConfig } from '@/ui/routes/types';

const logoLayoutRoutes: NamedRouteConfig[] = [
  {
    path: '/no-plan',
    name: 'noPlanPage',
    component: NoPlanPage,
    meta: {
      classes: 'centered-title-subtitle-layout',
    },
    beforeEnter: guardAuthenticatedRoutes,
  },
  {
    path: '/subscription-ended',
    name: 'subscriptionEndedPage',
    component: SubscriptionEndedPage,
    meta: {
      classes: 'centered-title-subtitle-layout',
    },
    beforeEnter: guardAuthenticatedRoutes,
  },
];

export default logoLayoutRoutes;
